/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ kpiCount: NonNullable<unknown>, groupCount: NonNullable<unknown>, total: NonNullable<unknown> }} Fair_Deep_Crab_RoarInputs */

const en_fair_deep_crab_roar = /** @type {(inputs: Fair_Deep_Crab_RoarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.kpiCount} KPIs × ${i?.groupCount} groups → ${i?.total} entries`)
};

const de_fair_deep_crab_roar = /** @type {(inputs: Fair_Deep_Crab_RoarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.kpiCount} Kennzahlen × ${i?.groupCount} Gruppen → ${i?.total} Einträge`)
};

/**
* | output |
* | --- |
* | "{kpiCount} KPIs × {groupCount} groups → {total} entries" |
*
* @param {Fair_Deep_Crab_RoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fair_deep_crab_roar = /** @type {((inputs: Fair_Deep_Crab_RoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Deep_Crab_RoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fair_deep_crab_roar(inputs)
	return de_fair_deep_crab_roar(inputs)
});